import { ref } from 'vue'

/**
 * Shared, dependency-free sync UI state (docs/concepts/sync-feedback.md §4.4).
 *
 * `syncDialogVisible` is set by SyncStatusDialog while it is open. While the dialog is
 * visible it shows every sync state in place, so other feedback channels (ambient toasts
 * from syncService, import-success toasts from the stores) suppress themselves to avoid
 * double feedback. Lives in its own module so stores and services can read it without
 * import cycles.
 */
export const syncDialogVisible = ref(false)
